module.exports = __webpack_public_path__ + "static/media/viewworkout.e7973579.mov";